module.exports = __webpack_public_path__ + "static/media/social-reach.c40a06b8.svg";